import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';
import {FundperformanceComponent} from "./components/fundperformance.component";

const routes = [{
            path:'fund',
            component:FundperformanceComponent,
            canActivate:[CanActivateViaAuthGuard]}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FundperformanceRoutingModule { }
